import api from '../api/index'
import router from '../../router'

const state = {
  event: {},
}

const mutations = {
  setEvent: function (state, payload) {
    state.event = payload
  }
}

const actions = {
  loadEvent: function (context, {eventId, raceId}) {
    api.getEvent(eventId, function (data) {
      let race = data.races.filter((race) => {
        return race.id == raceId
      })
      raceId = race.length > 0 ? race[0].id : data.races[0].id
      context.commit('setEvent', data)
      context.dispatch('loadRace', raceId)
      if (context.getters.mobile) {
        router.push({name: 'map', params: {domain: data.id, raceId: raceId}})
      } else {
        router.push({name: 'leaderboard', params: {domain: data.id, raceId: raceId}})
      }
    }, function(error){
      context.commit('setModal', true)
      // this.$modal.show('hello-world');
    })
  }
}

const getters = {
  event : state => {
    return state.event
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/event.js